import { FILTER_BY_DATE } from "../../dependencies/env";
import type { NonEmptyArray } from "../../types";

type GetFilterDatesParams = {
  date: string;
  regularOnly: boolean | null;
  discountDatesToShow: NonEmptyArray<string>;
};

export default function getFilterDates({
  date,
  regularOnly,
  discountDatesToShow,
}: GetFilterDatesParams) {
  // don't apply the date availability filter when it's disabled
  if (!FILTER_BY_DATE) {
    return;
  }

  // only apply the date filter when RT availability isn't shown
  if (regularOnly) {
    return;
  }

  // week view
  if (date === "week") {
    return discountDatesToShow;
  }

  // day view
  // only apply the date filter when it is a discount date (since the backend doesn't support filtering by dates outside the range of discount dates)
  if (discountDatesToShow.includes(date)) {
    return [date];
  }
}
